import { gql } from '@apollo/client';
import React from 'react';

import { CreditFactorTradelineSection } from '@generated-gql/generated-types';

import TradelineList, { TradelineListProps } from '../tradeline-list/index';
import HighlightWrapper from '../highlight-wrapper';

interface Component<E> extends React.FC<E> {
  fragment: any;
}

interface Props extends Omit<TradelineListProps, 'tradelines'> {
  section: CreditFactorTradelineSection;
}

const TradelineSection: Component<Props> = ({
  section,
  ...tradelineListProps
}) => (
  <HighlightWrapper section={section}>
    <TradelineList
      {...tradelineListProps}
      tradelines={section.tradelines || []}
    />
  </HighlightWrapper>
);
TradelineSection.fragment = gql`
  fragment tradelineSectionFragment on CreditFactorTradelineSection {
    ...highlightWrapperTradelineFragment
  }
  ${HighlightWrapper.fragment}
`;

export default TradelineSection;
